<div class="dev-console" *ngIf="isDev" [ngClass]="{'is-empty': (logs$ | async) === '--CLEAR'}">
    <div class="dev-console__inner" #content>
        {{logs$ | async}}
    </div>
</div>